require("./TweenMax.min.js");
import Vue from "vue";
import Vuex from "vuex";
import VueRouter from "vue-router";
import VueMeta from "vue-meta";
import App from "./components/App.vue";
import Product from "./components/Product.vue";
import OrderComplete from "./components/OrderComplete.vue";
import Shop from "./components/Shop.vue";
import vSelect from "./components/Select.vue";
import Contact from "./components/Contact.vue";
import ThreeD from "./components/ThreeD.vue";
import ErrorPage from "./components/ErrorPage.vue";
import TermsAndConditions from "./components/TermsAndConditions.vue";
import PrivacyPolicy from "./components/PrivacyPolicy.vue";
import ShippingAndReturns from "./components/ShippingAndReturns.vue";
import About from "./components/About.vue";

// Register components and services
Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(VueMeta);
Vue.component("v-select", vSelect);

// Register routes
var router = new VueRouter({
    mode: "history",
    routes: [
        { name: "home", path: "/", component: ThreeD },
        { name: "about", path: "/about", component: About },
        { name: "shop", path: "/shop", component: Shop },
        { name: "product", path: "/product/:id", component: Product },
        {
            name: "terms and conditions",
            path: "/termsandconditions",
            component: TermsAndConditions,
        },
        {
            name: "privacy policy",
            path: "/privacypolicy",
            component: PrivacyPolicy,
        },
        {
            name: "shipping and returns",
            path: "/shippingandreturns",
            component: ShippingAndReturns,
        },
        // { name: 'order', path: '/order', component: Order },
        { name: "contact", path: "/contact", component: Contact },
        { name: "threed", path: "/threed", component: ThreeD },
        {
            name: "order-complete",
            path: "/order-complete/:id",
            component: OrderComplete,
            props: true,
        },
        { name: "error-page", path: "*", component: ErrorPage },
    ],
});

router.beforeEach((to, from, next) => {
    //destroy videos to prevent memory leak
    if (from.name == "shop") {
        var videos = $("video");
        videos.each(function (i, e) {
            e.src = "";
            e.srcObject = null;
            e.remove();
        });
    }
    next();
});

const store = new Vuex.Store({
    state: {
        currency: String,
        ringChoice: {},
        cart: [],
        details: {},
    },
    // getters: {
    // 	getCart: function(){
    // 		return state.cart;
    // 	}
    // },
    mutations: {
        removeFromCart(state, index) {
            state.cart.splice(index, 1);
        },
        addToCart(state, newVal) {
            state.cart.push(newVal);
        },
        clearCart(state) {
            state.cart = [];
        },
        updateCurrency(state, newVal) {
            state.currency = newVal;
        },
        updateRing(state, newVal) {
            state.ringChoice = newVal;
        },
        updateDetails(state, newVal) {
            state.details = newVal;
        },
    },
});

// instantiate everything to DOM
new Vue({
    router,
    el: "#app",
    data() {
        return {
            order_details: {},
            masterRings: [],
        };
    },
    methods: {
        getCountry(addrComponents) {
            for (var i = 0; i < addrComponents.length; i++) {
                if (addrComponents[i].types[0] == "country") {
                    if (addrComponents[i].short_name == undefined) {
                        if (
                            addrComponents[i].address_components[0]
                                .short_name != undefined
                        ) {
                            return addrComponents[i].address_components[0]
                                .short_name;
                        }
                    } else {
                        return addrComponents[i].short_name;
                    }
                }
            }
            return false;
        },
    },
    store,
    created: function () {
        var self = this;

        AWS.config.region = "us-west-2"; // Region
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: "us-west-2:4d64ca9e-fd06-4129-9516-2c7b50c73473",
        });

        var s3 = new AWS.S3({ params: { Bucket: "artfuldodgersrings" } });
        var params = {
            Bucket: "artfuldodgersrings",
            Key: "example.JSON",
        };
        var ringsFromServer;
        s3.getObject(params, function (err, data) {
            if (err) {
                console.log(err, err.stack);
            } else {
                ringsFromServer = JSON.parse(data.Body).rings;
                ringsFromServer.forEach(function (ring) {
                    ring.variationIndex = 0;
                    ring.variations.forEach(function (variation) {
                        variation.imageIndex = 0;
                    });
                });
                self.masterRings = ringsFromServer;
            }
        });
        this.masterRings = ringsFromServer;

        function getAddress(latitude, longitude) {
            $.ajax(
                "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
                    latitude +
                    "," +
                    longitude +
                    "&key=" +
                    "AIzaSyBI__lpB-Ne0EFz-7ovnHCiQ4jR1bGGHRQ"
            ).then(function success(response) {
                var countryCode = self.getCountry(response.results);
                if (countryCode != undefined) {
                    switch (countryCode) {
                        case "NZ":
                            self.$store.commit("updateCurrency", "NZD");
                            break;
                        case "GB":
                            self.$store.commit("updateCurrency", "GBP");
                            break;
                        case "US":
                            self.$store.commit("updateCurrency", "USD");
                            break;
                        case "AU":
                            self.$store.commit("updateCurrency", "AUD");
                            break;
                        default:
                            self.$store.commit("updateCurrency", "EUR");
                            break;
                    }
                }
            });
        }

        ipLookUp();
        var tryGeolocate = function () {
            if ("geolocation" in navigator) {
                // check if geolocation is supported/enabled on current browser
                navigator.geolocation.getCurrentPosition(
                    function success(position) {
                        // for when getting location is a success
                        getAddress(
                            position.coords.latitude,
                            position.coords.longitude
                        );
                    },
                    function error(error_message) {
                        // for when getting location results in an error
                        // ipLookUp();
                        self.$store.commit("updateCurrency", "USD");
                    }
                );
            } else {
                // geolocation is not supported
                // get your location some other way
                // console.log("geolocation is not enabled on this browser");
                // ipLookUp();

                self.$store.commit("updateCurrency", "USD");
            }
        };
        function ipLookUp() {
            $.ajax("https://ipapi.co/json/").then(
                function success(response) {
                    //ADD OTHERS
                    switch (response.currency) {
                        case "NZD":
                            self.$store.commit("updateCurrency", "NZD");
                            break;
                        case "AUD":
                            self.$store.commit("updateCurrency", "AUD");
                            break;
                        case "GBP":
                            self.$store.commit("updateCurrency", "GBP");
                            break;
                        case "EUR":
                            self.$store.commit("updateCurrency", "EUR");
                            break;
                        default:
                            self.$store.commit("updateCurrency", "USD");
                    }
                },
                function fail(data, status) {
                    tryGeolocate();
                }
            );
        }
    },
    render: (h) => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js